var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHtml(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 32,
    width: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.6 17.6l4.6 4.4-4.4 4.4-.6-.8 3.6-3.6-3.8-3.6zm-5.6 0l.6.8-3.8 3.6 3.6 3.8-.6.6-4.4-4.4zm3.464-1.747l.973.231-2.906 12.261-.973-.231zM15.2 8h.8v3.6h2.2v.8h-3v-.2zm-5 0h1.2l.8 3 .8-3h1.4v4.2h-.8V8.8l-.8 3.4h-1L11 8.8v3.4h-.8zm-4 0h3.4v.8H8.4v3.6h-.8V8.6H6.2zm-4 0H3v1.6h1.6V8h.8v4.2h-.6v-1.8H3.2v1.8h-1zm3.6-8h18v2h2v2h-2v2h2V4h2v2h2v26h-24V14h2v16h20V8h-6V2h-14v4h-2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default ForwardRef;